module.exports = {
    promotion_id: '1466',
    promotion: 'jamesbondlotterychallenge',
    appUrl: '/jamesbondlotterychallenge',
};
